/* Source: /tmp/jacbuilder-deploy-scratch/deploy-8asygg26/features/organizations/PublishReport.jac */
import {__jacJsx, __jacSpawn} from "@jac/runtime";
import { Button } from "../../components/ui/button.js";
import { status_sentence } from "../../components/shared/Display.js";
import { __jacCallFunction } from "@jac/runtime";
import { useState } from "@jac/runtime";
import { useEffect } from "@jac/runtime";
import { _jac } from "@jac/prelude";
async function publish_report(incident_id, organization_id, person_id, claim_type, summary, reported_at, source_reference, original_content) {
  return await __jacCallFunction("publish_report", {"incident_id": incident_id, "organization_id": organization_id, "person_id": person_id, "claim_type": claim_type, "summary": summary, "reported_at": reported_at, "source_reference": source_reference, "original_content": original_content});
}
function PublishReport(props) {
  const {snapshot, onRefresh} = props;
  const [organizationId, setOrganizationId] = useState("");
  const [personId, setPersonId] = useState("");
  const [claimType, setClaimType] = useState("FOUND_SAFE");
  const [summary, setSummary] = useState("");
  const [reportedAt, setReportedAt] = useState("");
  const [reference, setReference] = useState("");
  const [original, setOriginal] = useState("");
  const [reviewing, setReviewing] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [notice, setNotice] = useState("");
  let organizations = snapshot.organizations;
  let organization = organizations.filter(o => (o.id === organizationId)).map(o => o);
  let person = snapshot.people.filter(p => (p.id === personId)).map(p => p);
  let selectedOrg = (_jac.builtin.bool(organization) ? organization[0] : null);
  let selectedPerson = (_jac.builtin.bool(person) ? person[0] : null);
  useEffect(() => {
    setOrganizationId("");
    setPersonId("");
    setReviewing(false);
    setNotice("");
    setError("");
  }, [snapshot.incident_id]);
  function loadExample() {
    let hospitals;
    let people;
    hospitals = snapshot.organizations.filter(o => (o.organization_type === "HOSPITAL")).map(o => o);
    people = snapshot.people.filter(p => (p.name === "Maya Gurung")).map(p => p);
    setOrganizationId((_jac.builtin.bool(hospitals) ? hospitals[0].id : ""));
    setPersonId(((people.length === 1) ? people[0].id : ""));
    setClaimType("FOUND_SAFE");
    setSummary("Admitted, stable condition");
    setReportedAt("2026-09-21T09:15");
    setReference("HOSPITAL-FORM-001");
    setOriginal("Fictional hospital intake report: Maya Gurung, age 24, was admitted in stable condition at 09:15 UTC on 21 September 2026.");
    setReviewing(false);
    setError("");
    setNotice("Example loaded. Check the selected person and review before publishing.");
  }
  function review(event) {
    event.preventDefault();
    setError("");
    setNotice("");
    if ((!selectedOrg || !selectedPerson)) {
      setError("Select a current organization and person record.");
      return;
    }
    if (((!reference.trim() || !summary.trim()) || !original.trim())) {
      setError("Report reference, summary, and original text are required.");
      return;
    }
    setReviewing(true);
  }
  async function publish() {
    let result;
    setBusy(true);
    setError("");
    setNotice("");
    try {
      result = await __jacCallFunction("publish_report", {"incident_id": snapshot.incident_id, "organization_id": organizationId, "person_id": personId, "claim_type": claimType, "summary": summary, "reported_at": reportedAt, "source_reference": reference, "original_content": original});
      if (!result) {
        setError("No response received. Keep the same report reference and retry to avoid duplicates.");
        setBusy(false);
        return;
      }
      if (result.error) {
        setError(result.error);
        setBusy(false);
        return;
      }
      setNotice((((((result.duplicate ? "Already published; no duplicate claim. " : "Report published. ")) + String(result.alerts_created)) + " new alert(s). Claim: ") + result.claim_id));
      setReviewing(false);
      await onRefresh();
    } catch (__jac_e) {
      if (_jac.exc.matches(__jac_e, "Exception")) {
        let e = __jac_e;
        setError(("Could not publish: " + String(e)));
      } else {
        throw __jac_e;
      }
    }
    setBusy(false);
  }
  return __jacJsx("section", {"className": "min-w-0 break-words rounded-md border border-border bg-card p-4 md:p-5"}, [__jacJsx("div", {"className": "mb-4 flex flex-wrap items-start justify-between gap-3"}, [__jacJsx("div", {}, [__jacJsx("h3", {"className": "font-display text-2xl"}, ["Publish a report"]), __jacJsx("p", {"className": "mt-1 max-w-2xl text-sm text-muted-foreground"}, ["Fictional demo institutions only. This selector does not verify an organization's identity. Every report keeps its source and history."])]), __jacJsx(Button, {"variant": "outline", "size": "sm", "disabled": busy, "onClick": loadExample}, ["Load hospital example"])]), ((organizations.length === 0) && __jacJsx("p", {"className": "mb-3 text-sm text-status-warning"}, ["No demo institutions yet. Use Reset demo in Demo controls to load the updated fixtures."])), __jacJsx("form", {"onSubmit": review, "className": "flex flex-col gap-4"}, [__jacJsx("fieldset", {"disabled": (busy || reviewing), "className": "grid min-w-0 gap-4 md:grid-cols-2 disabled:opacity-70"}, [__jacJsx("label", {"className": "flex min-w-0 flex-col gap-1 text-sm"}, [__jacJsx("span", {}, ["Demo organization"]), __jacJsx("select", {"required": true, "value": organizationId, "onChange": e => {
    setOrganizationId(e.target.value);
  }, "className": "h-11 w-full rounded-md border border-input bg-background px-3"}, [__jacJsx("option", {"value": ""}, ["Choose an organization"]), (() => {
    let __jac_view_kids = [false];
    __jac_view_kids[0] = (() => {
      let __jac_view_kids_1 = [];
      for (const org of organizations) {
        __jac_view_kids_1.push(__jacJsx("option", {"key": org.id, "value": org.id}, [org.name]));
      }
      return __jac_view_kids_1;
    })();
    return __jacJsx(null, {}, __jac_view_kids);
  })()])]), __jacJsx("label", {"className": "flex min-w-0 flex-col gap-1 text-sm"}, [__jacJsx("span", {}, ["Person record"]), __jacJsx("select", {"required": true, "value": personId, "onChange": e => {
    setPersonId(e.target.value);
  }, "className": "h-11 w-full rounded-md border border-input bg-background px-3"}, [__jacJsx("option", {"value": ""}, ["Choose an existing record"]), (() => {
    let __jac_view_kids_2 = [false];
    __jac_view_kids_2[0] = (() => {
      let __jac_view_kids_3 = [];
      for (const p of snapshot.people) {
        __jac_view_kids_3.push(__jacJsx("option", {"key": p.id, "value": p.id}, [((((p.name + " \u00b7 age ") + ((p.age ? String(p.age) : "unknown"))) + " \u00b7 record ") + p.id.slice((-6)))]));
      }
      return __jac_view_kids_3;
    })();
    return __jacJsx(null, {}, __jac_view_kids_2);
  })()])]), __jacJsx("label", {"className": "flex flex-col gap-1 text-sm"}, [__jacJsx("span", {}, ["Reported status"]), __jacJsx("select", {"value": claimType, "onChange": e => {
    setClaimType(e.target.value);
  }, "className": "h-11 rounded-md border border-input bg-background px-3"}, [(() => {
    let __jac_view_kids_4 = [false];
    __jac_view_kids_4[0] = (() => {
      let __jac_view_kids_5 = [];
      for (const status of ["FOUND_SAFE", "MISSING", "INJURED", "DECEASED", "SEEN_AT_LOCATION"]) {
        __jac_view_kids_5.push(__jacJsx("option", {"key": status, "value": status}, [status_sentence(status)]));
      }
      return __jac_view_kids_5;
    })();
    return __jacJsx(null, {}, __jac_view_kids_4);
  })()])]), __jacJsx("label", {"className": "flex flex-col gap-1 text-sm"}, [__jacJsx("span", {}, ["Reported time (UTC, optional)"]), __jacJsx("input", {"type": "datetime-local", "value": reportedAt, "onChange": e => {
    setReportedAt(e.target.value);
  }, "className": "h-11 min-w-0 rounded-md border border-input bg-background px-3"}, []), __jacJsx("span", {"className": "text-xs text-muted-foreground"}, ["Leave blank if unknown; ingestion time is recorded separately."])]), __jacJsx("label", {"className": "flex flex-col gap-1 text-sm md:col-span-2"}, [__jacJsx("span", {}, ["Report reference"]), __jacJsx("input", {"required": true, "maxLength": 300, "value": reference, "onChange": e => {
    setReference(e.target.value);
  }, "placeholder": "An institution's report ID or source reference", "className": "h-11 rounded-md border border-input bg-background px-3"}, []), __jacJsx("span", {"className": "text-xs text-muted-foreground"}, ["Retry with the same reference. Corrections need a new reference and retain the earlier report."])]), __jacJsx("label", {"className": "flex flex-col gap-1 text-sm md:col-span-2"}, [__jacJsx("span", {}, ["Report summary"]), __jacJsx("input", {"required": true, "maxLength": 2000, "value": summary, "onChange": e => {
    setSummary(e.target.value);
  }, "className": "h-11 rounded-md border border-input bg-background px-3"}, [])]), __jacJsx("label", {"className": "flex flex-col gap-1 text-sm md:col-span-2"}, [__jacJsx("span", {}, ["Original report text"]), __jacJsx("textarea", {"required": true, "rows": 3, "maxLength": 10000, "value": original, "onChange": e => {
    setOriginal(e.target.value);
  }, "className": "rounded-md border border-input bg-background p-3"}, [])])]), (!reviewing && __jacJsx("div", {}, [__jacJsx(Button, {"type": "submit", "disabled": (busy || (organizations.length === 0))}, ["Review report"])]))]), (reviewing && __jacJsx("div", {"className": "mt-4 flex min-w-0 flex-col gap-3 rounded-md border border-primary/40 bg-accent/30 p-4", "aria-label": "Report preview"}, [__jacJsx("h4", {"className": "font-medium"}, ["Review before publishing"]), __jacJsx("p", {"className": "text-sm"}, [(((((((selectedOrg ? selectedOrg.name : "Unknown institution")) + " reports ") + ((selectedPerson ? selectedPerson.name : "Unknown person"))) + " as ") + status_sentence(claimType)) + ".")]), __jacJsx("p", {"className": "text-sm"}, [summary]), __jacJsx("p", {"className": "text-xs text-muted-foreground"}, [((("Reference: " + reference) + " \u00b7 Reported: ") + ((reportedAt ? (reportedAt + " UTC") : "unknown")))]), __jacJsx("p", {"className": "whitespace-pre-wrap text-sm"}, [original]), __jacJsx("p", {"className": "text-xs text-muted-foreground"}, ["This adds a source claim and checks subscriptions for updates. Earlier reports stay available."]), __jacJsx("div", {"className": "flex flex-wrap gap-2"}, [__jacJsx(Button, {"disabled": busy, "onClick": publish}, [(busy ? "Publishing..." : "Publish demo report")]), __jacJsx(Button, {"variant": "outline", "disabled": busy, "onClick": () => {
    setReviewing(false);
  }}, ["Edit report"])])])), (error && __jacJsx("p", {"role": "alert", "className": "mt-3 text-sm text-destructive"}, [error])), (notice && __jacJsx("p", {"role": "status", "className": "mt-3 break-words text-sm text-status-safe"}, [notice]))]);
}
/*jac:refresh-boundary*/;
export {PublishReport};
if (typeof globalThis !== "undefined") { if (!globalThis.__jacEndpointEffects__) globalThis.__jacEndpointEffects__ = {}; Object.assign(globalThis.__jacEndpointEffects__, {"func:publish_report": {"is_writer": true, "touches": ["*"]}}); };
//# sourceMappingURL=PublishReport.js.map
